import { SET_IMAGE_PAIR, REMOVE_IMAGE_PAIR, CLEAR_IMAGE_PAIRS } from '../../constants/appTypes';

import { IImagePair } from '../../types/timeline';

const initialState: {
  imagePairs: Array<IImagePair>;
} = {
  imagePairs: []
};

interface selectedImagePairsAction {
  imagePair: IImagePair;
  type: string;
}

export function selectedImagePairs(state = initialState, action: selectedImagePairsAction) {
  let updatedPairs;
  switch (action.type) {
    case SET_IMAGE_PAIR:
      updatedPairs = [...state.imagePairs, action.imagePair]
      return { imagePairs: updatedPairs };
    case REMOVE_IMAGE_PAIR:
      updatedPairs = state.imagePairs.filter(pair => pair !== action.imagePair)
      return { imagePairs: updatedPairs}
    case CLEAR_IMAGE_PAIRS:
      return { imagePairs: [] };
    default:
      return state;
  }
}

export default selectedImagePairs;
